import { render } from "./ProviderUpdatePhoto.vue?vue&type=template&id=59305f79&scoped=true"
import script from "./ProviderUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./ProviderUpdatePhoto.vue?vue&type=script&lang=js"

import "./ProviderUpdatePhoto.vue?vue&type=style&index=0&id=59305f79&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59305f79"]])

export default __exports__